export default "__VITE_ASSET__DeKMktpv__"